(function(){
if(window.__mantraShip)return;window.__mantraShip=true;
var T1=1000,T2=2000;
var fmt=new Intl.NumberFormat('es-MX',{style:'currency',currency:'MXN',maximumFractionDigits:0});
function m(n){return fmt.format(n);}
var total=null,origFetch=window.fetch.bind(window),timer=null,raf=null,lastW='0%',sticky=null;
var isProd=location.pathname.indexOf('/products/')>-1;
function sv(i,s){return `<svg viewBox='0 0 24 24' width='${s}' height='${s}' fill='none' stroke='currentColor' stroke-width='1.6' stroke-linecap='round' stroke-linejoin='round'>${i}</svg>`;}
var ico={lock:sv(`<rect x='5' y='11' width='14' height='9' rx='2'/><path d='M8 11V8a4 4 0 0 1 8 0v3'/>`,22),truck:sv(`<path d='M3 7h11v9H3z'/><path d='M14 10h4l3 3v3h-7z'/><circle cx='7' cy='18' r='1.8'/><circle cx='17' cy='18' r='1.8'/>`,22),chat:sv(`<path d='M21 12a8 8 0 0 1-11.6 7.1L4 20l1-4.6A8 8 0 1 1 21 12z'/>`,22),card:sv(`<rect x='3' y='6' width='18' height='12' rx='2'/><path d='M3 10h18M7 15h3'/>`,16),wallet:sv(`<path d='M4 7h14a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2z'/><path d='M4 7l12-3v3'/><circle cx='16.5' cy='13.5' r='1'/>`,16),bank:sv(`<path d='M3 10l9-6 9 6'/><path d='M5 10v8M9.5 10v8M14.5 10v8M19 10v8M3 20h18'/>`,16)};
var payHtml=`<div class='mantra-pay'><span class='mantra-pay__chip'>${ico.card}Tarjetas</span><span class='mantra-pay__chip'>${ico.wallet}Mercado Pago</span><span class='mantra-pay__chip'>${ico.bank}Transferencia</span></div>`;
var trustHtml=`<div class='mantra-trust'><div class='mantra-trust__row'><div class='mantra-trust__item'>${ico.lock}<span>Pago seguro</span></div><div class='mantra-trust__item'>${ico.truck}<span>Envíos a todo México</span></div><div class='mantra-trust__item'>${ico.chat}<span>Atención por WhatsApp</span></div></div>${payHtml}</div>`;
var st=document.createElement('style');
st.textContent=`.mantra-ship{margin:1rem 0;padding:1rem 1.2rem;border:1px solid rgba(var(--color-foreground),.15);border-radius:8px;background:rgba(var(--color-foreground),.04);color:rgb(var(--color-foreground));font-size:1.3rem;line-height:1.4}
[data-mantra-ship=drawer]{margin:0 1.5rem 1rem}
.mantra-ship__msg{margin:0 0 .9rem}
.mantra-ship__track{position:relative;display:block;height:10px;border-radius:99px;background:rgba(var(--color-foreground),.15);overflow:hidden}
.mantra-ship__fill{display:block;height:100%;min-width:0;border-radius:99px;background:rgb(var(--color-button,0,0,0));transition:width .6s ease}
.mantra-ship__tick{position:absolute;top:0;left:50%;width:2px;height:100%;background:rgba(var(--color-background),.9);z-index:1}
.mantra-ship__legend{display:flex;justify-content:space-between;gap:.6rem;margin-top:.7rem;font-size:1.1rem;opacity:.75}
.mantra-ship--done .mantra-ship__fill{background:#2e9e5b}
.mantra-stock{margin:1rem 0;padding:.8rem 1.1rem;border-radius:8px;background:#fff4e5;border:1px solid #f5c98a;color:#8a4b00;font-size:1.35rem;font-weight:600}
.mantra-trust{margin:1.6rem 0 0}
.mantra-trust__row{display:grid;grid-template-columns:repeat(3,1fr);gap:.8rem}
.mantra-trust__item{display:flex;flex-direction:column;align-items:center;text-align:center;gap:.5rem;padding:1rem .4rem;border:1px solid rgba(var(--color-foreground),.12);border-radius:8px;font-size:1.15rem;line-height:1.25;color:rgb(var(--color-foreground))}
.mantra-pay{display:flex;flex-wrap:wrap;justify-content:center;gap:.6rem;margin:1rem 0 0}
.mantra-pay__chip{display:inline-flex;align-items:center;gap:.5rem;padding:.5rem 1rem;border:1px solid rgba(var(--color-foreground),.15);border-radius:99px;background:rgba(var(--color-foreground),.03);font-size:1.15rem;color:rgb(var(--color-foreground))}
.mantra-sticky{display:none}
@media (max-width:749px){.mantra-has-sticky body{padding-bottom:8rem}.mantra-sticky{display:flex;position:fixed;left:0;right:0;bottom:0;z-index:30;align-items:center;gap:1rem;padding:1rem 1.2rem calc(1rem + env(safe-area-inset-bottom,0px));padding-right:8.5rem;background:rgb(var(--color-background));border-top:1px solid rgba(var(--color-foreground),.15);box-shadow:0 -4px 14px rgba(0,0,0,.1);transform:translateY(110%);transition:transform .25s ease}.mantra-sticky.is-visible{transform:none}.mantra-sticky__info{display:flex;flex-direction:column;min-width:0;flex:1}.mantra-sticky__title{font-size:1.2rem;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;color:rgb(var(--color-foreground))}.mantra-sticky__price{font-size:1.4rem;font-weight:600;color:rgb(var(--color-foreground))}.mantra-sticky__btn{flex:0 0 auto;min-width:0;width:auto;padding:0 1.6rem;min-height:4.2rem}}`;
document.head.appendChild(st);
function build(t){
var done=t>=T2,msg;
var pct=Math.min(t/T2,1)*100;
if(done){msg='🎉 <strong>¡Tienes envío GRATIS!</strong>';}
else if(t>=T1){msg='🚚 Envío a solo <strong>$99</strong>. Agrega <strong>'+m(T2-t)+'</strong> más y es <strong>GRATIS</strong>';}
else{msg='🚚 Agrega <strong>'+m(T1-t)+'</strong> más y el envío baja a <strong>$99</strong>. ¡Gratis desde '+m(T2)+'!';}
return `<div class='mantra-ship${done?' mantra-ship--done':''}'><p class='mantra-ship__msg'>${msg}</p><span class='mantra-ship__track'><span class='mantra-ship__fill' style='width:${pct}%'></span><span class='mantra-ship__tick'></span></span><div class='mantra-ship__legend'><span>Envío $199</span><span>$99 desde ${m(T1)}</span><span>Gratis desde ${m(T2)}</span></div></div>`;
}
function upsert(key,anchor,pos,show,t){
var ex=document.querySelector('[data-mantra-ship='+key+']');
var sig=String(t);
if(!anchor||!show){if(ex)ex.remove();return;}
var posOk=ex&&((pos==='afterend'&&anchor.nextElementSibling===ex)||(pos==='beforebegin'&&anchor.previousElementSibling===ex));
var w=document.createElement('div');w.innerHTML=build(t);
var el=w.firstElementChild;
var fill=el.querySelector('.mantra-ship__fill');
var target=fill.style.width;
if(ex&&posOk){
if(ex.getAttribute('data-sig')===sig)return;
ex.className=el.className;
ex.querySelector('.mantra-ship__msg').innerHTML=el.querySelector('.mantra-ship__msg').innerHTML;
ex.querySelector('.mantra-ship__fill').style.width=target;
ex.setAttribute('data-sig',sig);
lastW=target;
return;
}
if(ex)ex.remove();
fill.style.width=lastW;
el.setAttribute('data-mantra-ship',key);
el.setAttribute('data-sig',sig);
anchor.insertAdjacentElement(pos,el);
requestAnimationFrame(function(){requestAnimationFrame(function(){fill.style.width=target;lastW=target;});});
}
function place(key,anchor,pos,html,sig){
var ex=document.querySelector('[data-mantra-x='+key+']');
if(!anchor||!html){if(ex)ex.remove();return;}
var ok=ex&&((pos==='afterend'&&anchor.nextElementSibling===ex)||(pos==='beforebegin'&&anchor.previousElementSibling===ex));
if(ok&&ex.getAttribute('data-sig')===sig)return;
if(ex)ex.remove();
var w=document.createElement('div');w.innerHTML=html;
var el=w.firstElementChild;
el.setAttribute('data-mantra-x',key);el.setAttribute('data-sig',sig);
anchor.insertAdjacentElement(pos,el);
}
function curVariant(){var i=document.querySelector('product-form input[name=id]');return i?i.value:null;}
function realBtn(){return document.querySelector('product-form button[name=add]');}
function initSticky(){
if(sticky)return;
var b=realBtn(),area=document.querySelector('.product-form__buttons');
if(!b||!area)return;
sticky=document.createElement('div');
sticky.className='mantra-sticky';
sticky.innerHTML=`<div class='mantra-sticky__info'><span class='mantra-sticky__title'></span><span class='mantra-sticky__price'></span></div><button type='button' class='mantra-sticky__btn button'></button>`;
document.body.appendChild(sticky);
document.documentElement.classList.add('mantra-has-sticky');
sticky.querySelector('.mantra-sticky__btn').addEventListener('click',function(){var r=realBtn();if(r&&!r.disabled)r.click();});
if('IntersectionObserver' in window){new IntersectionObserver(function(es){sticky.classList.toggle('is-visible',!es[0].isIntersecting);}).observe(area);}
}
function syncSticky(){
if(!sticky)return;
var r=realBtn();
var t=document.querySelector('.product__title');
var pe=document.querySelector('[id^=price-] .price');
var title=t?t.textContent.trim():document.title;
var pr='';
if(pe){var pel=pe.classList.contains('price--on-sale')?pe.querySelector('.price-item--sale'):pe.querySelector('.price-item--regular');pr=pel?pel.textContent.trim():'';}
var sp=r?r.querySelector('span'):null;
var lab=r?((sp?sp.textContent:r.textContent)||'').trim():'';
if(!lab)lab='Agregar al carrito';
var tt=sticky.querySelector('.mantra-sticky__title');if(tt.textContent!==title)tt.textContent=title;
var pp=sticky.querySelector('.mantra-sticky__price');if(pp.textContent!==pr)pp.textContent=pr;
var bt=sticky.querySelector('.mantra-sticky__btn');if(bt.textContent!==lab)bt.textContent=lab;
bt.disabled=!r||r.disabled;
}
function ensure(){
if(total!==null){
var t=total;
upsert('drawer',document.querySelector('cart-drawer .drawer__header'),'afterend',t>0,t);
upsert('cart',document.querySelector('cart-items .cart__contents'),'beforebegin',t>0,t);
var cd=t>0?document.querySelector('cart-drawer .cart__ctas'):null;
place('payd',cd,'afterend',cd?payHtml:'','p');
var cc=t>0?document.querySelector('#main-cart-footer .cart__ctas'):null;
place('payc',cc,'afterend',cc?payHtml:'','p');
var pt=null,pp='afterend';
if(isProd){
pt=document.querySelector('.product__tax');
if(!pt){pt=document.querySelector('.product-form__quantity');pp='beforebegin';}
if(!pt){pt=document.querySelector('product-form');pp='afterend';}
}
upsert('product',pt,pp,true,t);
}
if(isProd){
var vid=curVariant();
var q=(window.mantraStock&&vid!==null&&window.mantraStock[vid]!==undefined)?window.mantraStock[vid]:-1;
var bar=document.querySelector('[data-mantra-ship=product]');
var sh=(q>0&&q<=5)?`<div class='mantra-stock'>🔥 ${q===1?'¡Última pieza disponible!':'¡Solo quedan '+q+' piezas!'}</div>`:'';
place('stock',bar,'afterend',sh,String(q));
place('trust',document.querySelector('.product-form__buttons')||document.querySelector('product-form'),'afterend',trustHtml,'t');
initSticky();
syncSticky();
}
}
function refresh(){
origFetch('/cart.js',{headers:{Accept:'application/json'},cache:'no-store'}).then(function(r){return r.json();}).then(function(c){total=(c.total_price||0)/100;ensure();}).catch(function(){});
}
window.fetch=function(){
var a=arguments;
var u=typeof a[0]==='string'?a[0]:((a[0]&&a[0].url)||'');
var p=origFetch.apply(window,a);
if(/\/cart\/(add|change|update|clear)/.test(u)){p.then(function(){refresh();clearTimeout(timer);timer=setTimeout(refresh,600);}).catch(function(){});}
return p;
};
new MutationObserver(function(){if(raf)return;raf=requestAnimationFrame(function(){raf=null;ensure();});}).observe(document.body,{childList:true,subtree:true});
if(isProd)setInterval(ensure,700);
window.addEventListener('pageshow',function(e){if(e.persisted)refresh();});
refresh();
ensure();
})();
